import { toast } from "sonner";
import { useSettings, priceValue } from "@/lib/settings";
import { trackEvent } from "@/lib/tracking";
import { PremiumPriceDisplay } from "@/components/mystic/PremiumPriceDisplay";

export function GoldButton({
  children,
  testId,
  className = "",
  priceSize,
  priceCaption,
  tone = "dark",
  align = "center",
}) {
  const { settings } = useSettings();

  const handleClick = () => {
    if (settings.checkout_url) {
      trackEvent("InitiateCheckout", {
        value: priceValue(settings),
        currency: "BRL",
        content_name: "Meu Ex de Volta — 50 Simpatias",
        content_type: "product",
      });
      window.location.assign(settings.checkout_url);
    } else {
      toast.info("Checkout em configuração", {
        description: "O link de compra será ativado em breve.",
      });
    }
  };

  const button = (
    <button
      type="button"
      data-testid={testId}
      onClick={handleClick}
      className={`group relative inline-flex items-center justify-center gap-3 overflow-hidden rounded-full bg-gradient-to-r from-[#A47B2C] via-dourado to-[#F3E5C8] px-8 py-4 text-sm font-bold uppercase tracking-[0.14em] text-vinho shadow-[0_0_30px_rgba(214,175,98,0.35)] transition-[transform,box-shadow] duration-300 hover:scale-[1.04] hover:shadow-[0_0_45px_rgba(214,175,98,0.55)] focus:outline-none focus-visible:ring-2 focus-visible:ring-dourado focus-visible:ring-offset-2 focus-visible:ring-offset-obsidian active:scale-[0.98] sm:px-10 sm:py-5 sm:text-base ${className}`}
    >
      <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
      <span className="relative">{children}</span>
    </button>
  );

  if (!priceSize) return button;

  return (
    <span className={`inline-flex flex-col gap-4 ${align === "left" ? "items-start" : "items-center"}`}>
      <PremiumPriceDisplay
        size={priceSize}
        caption={priceCaption}
        align={align}
        tone={tone}
        testId={`${testId}-preco`}
      />
      {button}
    </span>
  );
}
